export const incorrectUserCredentials = 'Incorrect email, phone number or password.'
export const userLocked = 'Sphere User has locked'
